import styled from 'styled-components';

export const Container = styled.div`
  max-width: ${({ width }) => (width && width) || '1240px'};
  padding: 0 30px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
`;

export default Container;



// WEBPACK FOOTER //
// ./src/components/Container/index.js